/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type OfferDashboardDto = {
    id: string;
    order: number;
    imageMetadataId: string;
    name: string;
    displayPriorityZone: string;
    miles: number;
    status: OfferDashboardDto.status;
    effectiveFrom?: string;
    effectiveTo?: string;
    displayFrom?: string;
    isExclusiveForRetailer: boolean;
};

export namespace OfferDashboardDto {

    export enum status {
        DRAFT = 'DRAFT',
        ACTIVE = 'ACTIVE',
        DISABLED = 'DISABLED',
        EXPIRED = 'EXPIRED',
        UPCOMING = 'UPCOMING',
    }


}

